'use client';

import { useEffect } from 'react';
import { useTranslation } from '@/lib/i18n';
import { useRightDrawer } from '@/contexts/DrawerContext';
import MarketPulse from '../ui/MarketPulse';

export default function PortfolioSidebarRender() {
  const { t } = useTranslation();
  const { openDrawer, setDrawerWidth } = useRightDrawer();

  useEffect(() => {
    setDrawerWidth(400);
    openDrawer(<MarketPulse />, t('Events'), true);
  }, [openDrawer, setDrawerWidth, t]);

  return null;
}
